<div class="login-wrapper">
  <span class="logo">
    <img [src]="environment.logoImage" alt="" />
  </span>
  <form *ngIf="formState$ | async as formState" [formGroup]="loginForm" class="login-form">
    <div class="login-form__title">Login</div>
    <label>
      <span>ID or Email</span>
      <input data-e2e="login-email" formControlName="email" type="text" />
    </label>
    <label>
      <span>Password</span>
      <input data-e2e="login-password" formControlName="password" type="password" />
    </label>
    <span *ngIf="formState?.errors" class="login-form__error">Wrong email or password</span>
    <div class="login-form__buttons">
      <button (click)="signIn()" [disabled]="formState?.errors" class="login-btn" data-e2e="login-submit">Log In
      </button>
      <button
        (click)="getLoginUseMicrosoft()"
        *ngIf="isLoginWithMicrosoft"
        class="sign-with-microsoft">
        <img alt="microsoft" src="assets/img/icons/icons8-microsoft.svg" />
        Sign in
      </button>
    </div>
  </form>
</div>
